import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import ReactionIcon from '../../../modules/comments/reactions/components/reaction-icon';
import {REACTION_ICON_SIZES} from '../../../modules/comments/reactions/constants';

import styles from './article-reaction.module.css';

const ArticleReactionButton = ({
  isActive,
  onClick,
  count,
  type,
  size,
  children,
  variant
}) => {
  const variants = {
    secondary: styles.secondary,
    primary: styles.primary
  };

  return (
    <div className={styles.wrapper}>
      <button
        onClick={() => onClick(type)}
        className={clsx(styles.button, variants[variant], {
          [styles.activeButton]: isActive
        })}
      >
        <ReactionIcon type={type} size={size} />
        {count}
      </button>
      {children}
    </div>
  );
};

ArticleReactionButton.propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  count: PropTypes.number,
  type: PropTypes.string.isRequired,
  size: PropTypes.number,
  children: PropTypes.oneOf([PropTypes.node, null]),
  variant: PropTypes.oneOf(['primary', 'secondary'])
};

ArticleReactionButton.defaultProps = {
  isActive: false,
  count: 0,
  size: REACTION_ICON_SIZES.BIG,
  variant: 'primary',
  children: null
};

export default ArticleReactionButton;
